import PropTypes from '../vue-types';

export var storeShape = PropTypes.shape({
  subscribe: PropTypes.func.isRequired,
  setState: PropTypes.func.isRequired,
  getState: PropTypes.func.isRequired
});


//////////////////
// WEBPACK FOOTER
// ./~/ant-design-vue/es/_util/store/PropTypes.js
// module id = 648
// module chunks = 0